module.exports = __webpack_public_path__ + "static/media/01.888063d0.png";